
import { mapGetters } from 'vuex'
import { Currency } from '~/plugins/Currency'
import Purchase from '../PurchaseAction/Purchase.vue'
import ProductSubscriptionButton from '../ProductSubscription/ProductSubscriptionButton.vue'
export default {
  components: { Purchase, ProductSubscriptionButton },
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
          id: 0,
        }
      },
    },
    canUserBuyWithSubscription: {
      type: Boolean,
      default: false,
    },
    subscriptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showPayments: false,
    }
  },
  computed: {
    ...mapGetters({
      getUserIP: 'user/getUserIP',
      getActiveUser: 'user/getActiveUser',
    }),
    commentLength() {
      return this.product.comments === null ? 0 : this.product.comments.length
    },
    starAvg() {
      if (this.product.comments === null) return 0
      if (this.product.comments.length === 0) return 0
      const length =
        this.product.comments === null ? 0 : this.product.comments.length
      const totalStar = this.product.comments.reduce(
        (sum, { point }) => sum + point,
        0
      )
      return Math.round(totalStar / length)
    },
  },
  methods: {
    Currency(p) {
      return Currency(p, this.getUserIP.currency)
    },
  },
}
